import handleToggle from '../common/handleToggle';

function registerInputEvents(component) {
    $(component).on('focus', handleToggle(component, true));
    $(component).on('blur', () => {
        const hasValue = Boolean(component.value.length);
        handleToggle(component, hasValue)();
    });
}

export default registerInputEvents;



// WEBPACK FOOTER //
// ./src/scripts/components/form/registerInputEvents.js